import { render } from "./SaveBtn.vue?vue&type=template&id=e5e772ba&ts=true"
import script from "./SaveBtn.vue?vue&type=script&lang=ts"
export * from "./SaveBtn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__